export const DEFAULT_PAGE_RANGE_DISPLAYED = 2;
